<template>
    <span>{{this.params.data.active ? 'active' : 'not active'}}</span>
</template>

<script>
    export default {
        name: 'CellRendererMembership'
    }
</script>
